import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AuditDialogContent from './auditDialogContent';
import { useQueryAuditTrailInfoPagination } from '../../../../hooks/useAuditTrail';

const AuditTrailContent = props => {
  const [auditTrailRecors, setAuditTrailRecords] = useState([]);
  const { eventMeta, unread } = props;

  const { data, isFetching, hasNextPage, isFetchingNextPage, fetchNextPage } = useQueryAuditTrailInfoPagination(
    eventMeta.skybox_id
  );

  const lastPage = data?.pages?.[data.pages.length - 1];

  useEffect(() => {
    const newItems = lastPage?.items ?? [];
    setAuditTrailRecords(prev => [...prev, ...newItems]);
  }, [data?.pages.length]);

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage]);

  return (
    <div>
      <AuditDialogContent
        eventId={eventMeta.event_id}
        isFetching={isFetching}
        data={auditTrailRecors}
        unread={unread}
      />
    </div>
  );
};

AuditTrailContent.propTypes = {
  eventMeta: PropTypes.object.isRequired,
  unread: PropTypes.array.isRequired,
};

export default AuditTrailContent;
